/* eslint-disable import/prefer-default-export */
import client from '../helpers/HttpClient';

export const buildCsvData = async (model, filter = {}) => {
  const params = new URLSearchParams(filter).toString();
  await client.get(`api/${model}_export_data?${params}`)
};
